/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import { ButtonGroup as BaseButtonGroup } from 'reactstrap'

import { FONTS } from '../../constants'
import Button from '../../lib/components/Button'

const ButtonGroup = styled(BaseButtonGroup)`
  margin: 12px 0;
  background-color: #fff;

  ${Button} {
    height: 36px;
  }
`

const Toggle = styled.div`
  width: auto;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => (p.active ? '#D44B49' : '#FFFFFF')};
  color: ${p => (p.active ? '#FFFFFF' : '#808080')};
  border: ${p => (p.active ? '1px solid #AD2624' : '1px solid #F2F2F2')};
  font-family: ${p => (p.active ? FONTS.GOTHAM_BOLD : FONTS.GOTHAM)};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 8px;
  cursor: pointer;

  :nth-child(1) {
    border-radius: 4px 0 0 4px;
  }

  :nth-child(3) {
    border-radius: 0 4px 4px 0;
  }

  :hover {
    ${p => !p.active && `
      background: rgba(212, 75, 73, 0.08);
      border: 1px solid #AD2624;
      color: #D44B49;
    `}
  }
`

/**
 * @typedef {object} Props
 * @property {boolean[]} privileged
 * @property {string} activeTab
 * @property {(name: string) => void} onChangeTab
 */

/**
 * @extends {React.Component<Props, *>}
 */
class DataDisplayTab extends React.Component {
  componentWillUnmount = () => {
    this.props.onChangeTab('overview')
  }

  /**
   * @param {string} tabname
   */
  switchTab = tabname => () => {
    this.props.onChangeTab(tabname)
  }

  render = () => {
    const { privileged, activeTab } = this.props
    return (
      <ButtonGroup>
        {privileged[0] && (
          <Toggle
            onClick={ this.switchTab('overview') }
            active={ activeTab === 'overview' }
          >
            Overview (PM)
          </Toggle>
        )}
        {privileged[1] && (
          <Toggle
            onClick={ this.switchTab('standard') }
            active={ activeTab === 'standard' }
          >
            Display Standard Costs
          </Toggle>
        )}
        {privileged[2] && (
          <Toggle
            onClick={ this.switchTab('actual') }
            active={ activeTab === 'actual' }
          >
            Display Actual Costs
          </Toggle>
        )}
        {/* {privileged[0] && (
          <Button
            onClick={ this.switchTab('overview') }
            outline={ activeTab !== 'overview' }
            color="danger"
          >
            Overview (PM)
          </Button>
        )}
        {privileged[1] && (
          <Button
            onClick={ this.switchTab('standard') }
            outline={ activeTab !== 'standard' }
            color="danger"
          >
            Display Standard Costs
          </Button>
        )}
        {privileged[2] && (
          <Button
            onClick={ this.switchTab('actual') }
            outline={ activeTab !== 'actual' }
            color="danger"
          >
            Display Actual Costs
          </Button>
        )} */}
      </ButtonGroup>
    )
  }
}

export default DataDisplayTab



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/DataDisplayTab.jsx